export default __webpack_public_path__ + "static/media/download-icon.e8db3c87.svg";